import styled from 'styled-components';
import { select } from '../../../core/themev2';

const DropDownOption = styled.div`
  width: ${({ width }) => width};
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 258px;
  background-color: ${select('white')};
  box-shadow: 0px 4px 11px 9px rgba(166, 166, 166, 0.05);
  border: 1px solid ${({ borderColor }) => select(borderColor)};
  border-radius: 8px;
  padding: 8px 0;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  top: 4px;
  border-top-right-radius: 8px !important;
  border-top-left-radius: 8px !important;
  z-index: 1;
  &::-webkit-scrollbar {
    width: 8px;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${select('midLightGray')};
    border-radius: 8px;
  }
`;

export { DropDownOption };
